// src/i18n/en/benchmark.ts
// English counterpart of i18n/es/benchmark.ts - see there for context.
export const benchmark = {
  name: 'Hotel comparison |||| Hotel comparison',
  subtitle: 'Arrivals resolved without reception in the chosen period, against your chain median',

  summary: {
    title: 'Properties with data',
    withRates: '%{count} of %{total} chain properties have enough data in this period.',
  },

  ranking: {
    title: 'Ranking by arrivals resolved without reception',
    property: 'Property',
    containment: 'Resolved without reception',
    medianMarker: 'Chain median: %{value}',
    empty: 'No other property shares this chain, or none has enough data.',
    medianMissing: 'No chain median: %{reason}',
  },

  own: {
    title: 'Your hotel against the chain median',
    titleMany: 'Your hotels against the chain median',
    median: 'Chain median',
    note: 'Your access shows only your hotel; the other chain hotels count towards the median but are not listed.',
    noteMany: 'Your access shows only your hotels; the other chain hotels count towards the median but are not listed.',
  },

  export: {
    property: 'Property',
    containment: 'Resolved without reception',
    remedy: 'Remedy',
  },

  help: {
    title: 'Hotel comparison',
    description:
      'Compares the share of each chain hotel\'s arrivals resolved without going through reception, with the chain median marked, and how many hotels have enough data in the period. Users who see the whole chain get the full ranking; users who see one hotel get their hotel against the median.',
    features: {
      list: 'A property without a figure is listed last, with no rank number, with the reason (insufficient sample, no reservations received, unreliable event delivery or business day not configured), never with a zero. Withdrawn or merged properties do not count.',
    },
    tips: {
      property: 'Switch property at the top left; the default period is the last 30 days.',
    },
  },
};

export default benchmark;
